/**
 * "Added to cart" toast.
 * Shown for 2 seconds after a product is successfully added to the cart, when the cart drawer
 * is not going to open (drawer disabled / "After adding to cart" set to "Do nothing").
 * Works for both the on-page Add to cart button and the sticky Add to cart bar.
 */
(function () {
  if (window.__atcToastLoaded) return;
  window.__atcToastLoaded = true;

  var VISIBLE_MS = 2000;
  var FADE_MS = 200;
  var MESSAGE = 'Added to cart successfully';
  var toast = null;
  var hideTimer = null;
  var removeTimer = null;

  function injectStyles() {
    if (document.getElementById('atc-toast-styles')) return;
    var style = document.createElement('style');
    style.id = 'atc-toast-styles';
    style.textContent =
      '.atc-toast{position:fixed;top:16px;left:50%;z-index:99999;display:flex;align-items:center;gap:10px;' +
      'max-width:calc(100% - 32px);padding:12px 20px;border-radius:6px;background:#111;color:#fff;' +
      'font-size:14px;font-weight:600;line-height:1.3;box-shadow:0 6px 24px rgba(0,0,0,.25);' +
      'transform:translate(-50%,12px);opacity:0;pointer-events:none;' +
      'transition:opacity ' + FADE_MS + 'ms ease,transform ' + FADE_MS + 'ms ease}' +
      '.atc-toast.is-visible{opacity:1;transform:translate(-50%,0)}' +
      '.atc-toast__icon{flex:0 0 auto;width:20px;height:20px;border-radius:50%;background:#2e9e5b;' +
      'display:flex;align-items:center;justify-content:center}' +
      '.atc-toast__icon svg{width:12px;height:12px}' +
      '.atc-toast{width:max-content!important;max-width:calc(100vw - 24px)!important;white-space:nowrap!important}' +
      '.atc-toast__text{white-space:nowrap!important;word-break:keep-all!important;overflow-wrap:normal!important}' +
      '@media (max-width:768px){.atc-toast{top:auto!important;bottom:16px!important;transform:translate(-50%,12px);gap:8px!important;padding:10px 14px!important;font-size:12px!important}' +
      '.atc-toast__text{font-size:12px!important;letter-spacing:0!important}' +
      '.atc-toast__icon{width:16px!important;height:16px!important}.atc-toast__icon svg{width:10px!important;height:10px!important}}' +
      '@media (prefers-reduced-motion:reduce){.atc-toast{transition:none}}';
    document.head.appendChild(style);
  }

  // The Add to cart button the shopper actually pressed (main PDP button or the sticky bar button)
  var lastBtn = null;
  document.addEventListener(
    'click',
    function (e) {
      // Ignore programmatic clicks (the sticky bar calls the main button's .click() itself)
      if (!e.isTrusted || !e.target || !e.target.closest) return;
      var btn = e.target.closest('[data-sticky-btn], product-form [name="add"], product-form button[type="submit"]');
      if (btn) lastBtn = btn;
    },
    true
  );

  // Show the toast centred just above the pressed Add to cart button.
  // Falls back to the top (desktop) / above the sticky bar (mobile) if the button is not on screen.
  function positionToast() {
    if (!toast) return;
    var set = function (prop, val) { toast.style.setProperty(prop, val, 'important'); };
    var clear = function (prop) { toast.style.removeProperty(prop); };

    if (lastBtn && lastBtn.isConnected) {
      var r = lastBtn.getBoundingClientRect();
      if (r.width && r.height && r.bottom > 0 && r.top < window.innerHeight) {
        var half = toast.offsetWidth / 2;
        var vw = document.documentElement.clientWidth;
        var cx = Math.min(Math.max(r.left + r.width / 2, half + 12), vw - half - 12);
        set('left', cx + 'px');
        set('top', 'auto');
        set('bottom', Math.max(window.innerHeight - r.top + 12, 12) + 'px');
        return;
      }
    }

    clear('left');
    clear('top');
    if (!window.matchMedia('(max-width: 768px)').matches) {
      clear('bottom');
      return;
    }
    var offset = 16;
    var panel = document.querySelector('sticky-atc-panel');
    if (panel && !panel.classList.contains('sticky-atc-panel--out') && panel.offsetHeight) {
      offset += panel.offsetHeight;
    }
    set('bottom', offset + 'px');
  }

  function buildToast() {
    var el = document.createElement('div');
    el.className = 'atc-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<span class="atc-toast__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 12 12" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M2.5 6.2l2.4 2.4 4.6-5"/></svg></span>' +
      '<span class="atc-toast__text"></span>';
    el.querySelector('.atc-toast__text').textContent = MESSAGE;
    return el;
  }

  function show() {
    injectStyles();
    clearTimeout(hideTimer);
    clearTimeout(removeTimer);

    if (!toast || !toast.isConnected) {
      toast = buildToast();
      document.body.appendChild(toast);
    }
    positionToast();

    // Next frame so the fade-in transition runs
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        toast.classList.add('is-visible');
      });
    });

    hideTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      removeTimer = setTimeout(function () {
        if (toast && toast.parentNode) toast.parentNode.removeChild(toast);
        toast = null;
      }, FADE_MS + 50);
    }, VISIBLE_MS);
  }

  function shouldShow(evt) {
    var target = evt.target;
    // Only for product forms (not the cart page quantity changes)
    if (!target || !target.closest || !target.closest('product-form')) return false;
    // The quick-add popup has its own "Added to cart" message
    if (target.closest('quick-add-drawer')) return false;

    var s = (window.theme && window.theme.settings) || {};
    // These two navigate to the cart page instead
    if (s.afterAtc === 'page' || s.afterAtc === 'no-js') return false;

    var drawerWillOpen =
      s.afterAtc === 'drawer' && s.cartType === 'drawer' && !!document.querySelector('cart-drawer');
    return !drawerWillOpen;
  }

  function onAdded(evt) {
    if (shouldShow(evt)) show();
  }

  // Fired by product-form.js after a successful add (new item / item already in the cart)
  document.addEventListener('on:cart:add', onAdded);
  document.addEventListener('on:line-item:change', onAdded);
})();